import React, { useEffect} from "react";
import Hero from "../components/Hero";
import homeImg from "../assets/Home page image 1.png";
import service1 from "../assets/cloth ironing image(Home).png";
import service2 from "../assets/cloth laundry image (Home).png";


export default function Home() {
  

  useEffect(() => {
    const elements = document.querySelectorAll(".reveal");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("active");
        });
      },
      { threshold: 0.2 }
    );
    elements.forEach((el) => observer.observe(el));
  }, []);

  return (
    <div>
      {/* ============================ INTERNAL CSS =============================== */}
      <style>{`
        * { box-sizing: border-box; }
        body { overflow-x: hidden; }

        .reveal { opacity: 0; transform: translateY(40px); transition: all 0.8s ease-out; }
        .reveal.active { opacity: 1; transform: translateY(0); }

       

 /* =============== DARK SKY‑BLUE BUBBLES =============== */


  opacity: 0.9;
  animation: riseBubbleDarkSky 12s linear infinite;
}

/* Rising and drifting animation */
@keyframes riseBubbleDarkSky {
  0% {
    transform: translate(0px, 0px) scale(0.8);
    opacity: 0.3;
  }
  20% {
    transform: translate(10px, -120px) scale(1.0);
    opacity: 0.85;
  }
  40% {
    transform: translate(-10px, -280px) scale(1.1);
    opacity: 0.75;
  }
  60% {
    transform: translate(15px, -450px) scale(1.2);
    opacity: 0.6;
  }
  80% {
    transform: translate(-8px, -650px) scale(1.28);
    opacity: 0.45;
  }
  100% {
    transform: translate(10px, -900px) scale(1.3);
    opacity: 0;
  }
}

/* Positions & sizes */
.b1  { left: 5%;  width: 100px; height: 100px; animation-delay: 0s; }
.b2  { left: 12%; width: 140px; height: 140px; animation-delay: 2s; }
.b3  { left: 22%; width: 80px;  height: 80px;  animation-delay: 4s; }
.b4  { left: 35%; width: 170px; height: 170px; animation-delay: 1.5s; }
.b5  { right: 15%; width: 200px; height: 200px; animation-delay: 3.5s; }
.b6  { right: 25%; width: 110px; height: 110px; animation-delay: 5.5s; }
.b7  { left: 45%; width: 130px; height: 130px; animation-delay: 2.8s; }
.b8  { left: 55%; width: 180px; height: 180px; animation-delay: 4.2s; }
.b9  { right: 40%; width: 90px;  height: 90px;  animation-delay: 6s; }
.b10 { right: 8%;  width: 150px; height: 150px; animation-delay: 1s; }

        /* SERVICES GRID */
        .services-grid {
          width: 70%;
          margin: 60px auto;
          display: grid;
          grid-template-columns: 1fr 1fr;
          grid-template-rows: 350px 350px;
          border-radius: 10px;
          overflow: hidden;
        }

        /* CTA BOX */
        .cta-box {
          background: #0F1B47;
          color: white;
          padding: 60px;
          border-radius: 15px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 50px auto;
          width: 70%;
          position: relative;
          overflow: hidden;
        }

        .cta-btn {
          background: #1b7a9fff;
          border: none;
          color: white;
          padding: 15px 35px;
          border-radius: 50px;
          font-size: 18px;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 10px;
        }

     
        /* MEDIA QUERIES OMITTED FOR BREVITY, KEEP AS YOU HAD */
        * { box-sizing: border-box; }
  body { overflow-x: hidden; }

  /* Reveal animation */
  .reveal { opacity: 0; transform: translateY(40px); transition: all 0.8s ease-out; }
  .reveal.active { opacity: 1; transform: translateY(0); }

  
  /* Services grid and CTA styles remain unchanged... */

  /* ===================== MEDIA QUERIES ===================== */
  @media (max-width: 1024px) {
    
    .services-grid { width: 85%; grid-template-columns: 1fr; grid-template-rows: auto; }
    .cta-box { width: 85%; padding: 40px; flex-direction: column; gap: 25px; text-align: center; }
  }



@media (max-width: 768px) {
  
}


  @media (max-width: 768px) {
        .cta-btn { padding: 12px 28px; font-size: 16px; }
    .services-grid { width: 90%; gap: 20px; }
    .services-grid div, .services-grid img { height: 250px; }
  }

  @media (max-width: 480px) {
   
    .cta-box { width: 95%; padding: 30px; }
    .cta-btn { padding: 10px 22px; font-size: 14px; }
    .services-grid div, .services-grid img { height: 200px; }
    .about-section { flex-direction: column; gap: 25px; }
  }
      `}</style>

      {/* =============================== PAGE CONTENT =============================== */}
      <div>
          <Hero />
  {/* =================== ABOUT COMPANY SECTION =================== */}
<div className="reveal" style={{
  display: "flex",
  alignItems: "center",
  padding: "80px 20px",
  gap: "60px",
  flexWrap: "wrap",
  background: "#f7f9fc",
  borderRadius: "20px",
  margin: "50px auto",
  maxWidth: "1200px"
}}>
  {/* Company Photo */}
<img
  src={homeImg}
  alt="Company"
  style={{
    width: "100%",
    maxWidth: "400px",   // control max size
    height: "auto",
    borderRadius: "20px",
    objectFit: "contain",
    marginBottom: "20px",
    boxShadow: "0px 10px 25px rgba(0,0,0,0.1)",
  }}
/>


  {/* Company Details */}
  <div style={{ flex: "2 1 600px" }}>
    <h2 style={{ fontSize: "40px", fontWeight: "700", marginBottom: "15px", lineHeight: "1.2" }}>
      <span style={{ fontSize: "56px", color: "#1b7a9fff" }}>Rapid Wash</span> Laundry & Dry Cleaning Services
    </h2>
    <p style={{ fontSize: "18px", fontWeight: "600", color: "#333", marginBottom: "10px" }}>
     
    </p>
    <p style={{ fontSize: "16px", lineHeight: "1.8", color: "#555", marginBottom: "15px" }}>
     Rapid Wash Laundry & Dry Cleaning Services has been setting industry standards with exceptional quality and reliability. We provide comprehensive laundry solutions, catering to individuals, families, and corporate clients. Our focus is on precision, efficiency, and the use of eco-friendly detergents and modern technology to deliver spotless results every time.

Founded by A Group of  New Age Minds to Redefine, our mission is to redefine the laundry experience by combining convenience with excellence. Whether it’s delicate fabrics, heavy garments, or bulk orders, we handle each item with care and professionalism. Our team is trained to ensure your garments retain their quality, color, and freshness.

At Rapid Wash, we go beyond just cleaning. We offer timely pickups, doorstep deliveries, and personalized service, making laundry stress-free for our clients. We believe that clean clothes lead to a confident day, and we are committed to bringing that assurance to every home and business we serve.
    </p>
   
  </div>
</div>

         <div>
  {/* other content above */}

  <section className="process-wrapper">

    <style>{`
      .process-wrapper .process-section {
        text-align: center;
        padding: 80px 20px;
      }

      .process-wrapper .process-badge {
        display: inline-block;
        background: #eef2ff;
        color: #1b7a9f;
        padding: 10px 22px;
        border-radius: 30px;
        font-weight: 600;
        font-size: 14px;
      }

      .process-wrapper .process-title {
        margin-top: 20px;
        font-size: 36px;
        font-weight: 700;
      }

      .process-wrapper .process-steps {
        margin-top: 60px;
        display: flex;
        justify-content: center;
        gap: 60px;
        flex-wrap: wrap;
      }

      .process-wrapper .process-card {
        max-width: 330px;
        text-align: center;
      }

      .process-wrapper .process-icon {
        width: 120px;
        height: 120px;
        background: #1b7a9f;
        border-radius: 50%;
        margin: 0 auto 25px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .process-wrapper .process-icon img {
        width: 55px;
        filter: brightness(0) invert(1);
      }

      .process-wrapper .process-card h3 {
        font-size: 22px;
        font-weight: 600;
        margin-bottom: 15px;
      }

      .process-wrapper .process-card p {
        font-size: 16px;
        color: #555;
        line-height: 1.6;
      }
    `}</style>

    <div className="process-section reveal">
      <span className="process-badge">Our Process</span>
      <h2 className="process-title">This is how we work</h2>

      <div className="process-steps">
        {[
          {
            img: "https://cdn-icons-png.flaticon.com/512/892/892458.png",
            title: "We Collect Your Clothes",
            desc: "We collect your clothes as soon as you ask for it. Our trained personnel ensure seamless process of collecting."
          },
          {
            img: "https://cdn-icons-png.flaticon.com/512/3101/3101166.png",
            title: "We Wash Your Clothes",
            desc: "The automated process starts as soon as your clothes go into the machine. Ensuring right treatment to right fabric."
          },
          {
            img: "https://cdn-icons-png.flaticon.com/512/679/679720.png",
            title: "Get Delivery",
            desc: "We deliver your clothes as 'new' with tailored packaging and personal care."
          }
        ].map((item, index) => (
          <div key={index} className="process-card reveal">
            <div className="process-icon">
              <img src={item.img} alt={item.title} />
            </div>
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>
    </div>

  </section>

 
</div>

        {/* ------------------ SERVICES SECTION ------------------ */}
        <div className="reveal" style={{ textAlign: "center", padding: "50px 20px" }}>
          <h2 style={{ fontSize: "32px", fontWeight: "700" }}>
            Services we offer
          </h2>

          <div className="services-grid reveal">
            <img
              src={service2}
              alt=""
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />

            <div style={{
              background: "#1b7a9fff",
              color: "white",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              padding: "20px"
            }}>
              <img
                src="https://cdn-icons-png.flaticon.com/512/3101/3101166.png"
                style={{ width: "70px", marginBottom: "15px", filter: "brightness(0) invert(1)" }}
                alt=""
              />
              <h3 style={{ fontSize: "22px", fontWeight: "600" }}>Cloth Laundry</h3>
              <p style={{ width: "70%", marginTop: "10px", lineHeight: "1.6" }}>
                Your clothes cleaned with care and precision.
              </p>
            </div>

            <div style={{
              background: "#1b7a9fff",
              color: "white",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              padding: "20px"
            }}>
              <img
                src="https://cdn-icons-png.flaticon.com/512/4150/4150855.png"
                style={{ width: "70px", marginBottom: "15px", filter: "brightness(0) invert(1)" }}
                alt=""
              />
              <h3 style={{ fontSize: "22px", fontWeight: "600" }}>Cloth Ironing</h3>
              <p style={{ width: "70%", marginTop: "10px", lineHeight: "1.6" }}>
                Sharp, crisp ironing done professionally.
              </p>
            </div>

            <img
              src={service1}
              alt=""
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </div>
        </div>

        {/* ------------------ CTA SECTION ------------------ */}
        <div className="cta-box reveal">
          <div>
            <h2 style={{ fontSize: "32px", fontWeight: "700" }}>Call us for a service</h2>
            <p style={{ marginTop: "10px", fontSize: "18px", opacity: 0.9 }}>
              We deliver the goods to the most complicated places on earth
            </p>
          </div>

          <button className="cta-btn">
            <span style={{ fontSize: "20px" }}>📞</span> Learn More
          </button>

          <div className="bubble bubble1"></div>
          <div className="bubble bubble2"></div>
          <div className="bubble bubble3"></div>
       </div>
      </div>
    </div>
    
  );
}
